export enum AdhocAdvancePaymentStatus {
Pending,
Payment,
Clearance,
Canceled,
}
